function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M511.533 68.1426C266.14 68.1426 67.2087 267.073 67.2087 512.467C67.2087 757.861 266.14 956.792 511.533 956.792C756.927 956.792 955.858 757.861 955.858 512.467C955.858 267.073 756.927 68.1426 511.533 68.1426ZM0 512.467C0 229.955 229.021 0.933841 511.533 0.933841C794.045 0.933841 1023.07 229.955 1023.07 512.467C1023.07 794.979 794.045 1024 511.533 1024C229.021 1024 0 794.979 0 512.467Z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 512.467C0 274.908 161.906 75.2497 381.339 17.6585L410.257 76.8757C303.811 158.112 235.231 286.202 235.231 430.323C235.231 546.199 257.23 647.923 337 730.197C338.282 730.924 346.946 740.333 348.235 741.111C358.417 746.269 383.539 764.68 404 773C428.273 782.87 462.057 791.49 467 793.344L579.802 798.55L470.441 823.405C454.013 827.139 437.072 828.69 421.922 829.158V829.842C402.669 829.842 383.652 828.777 364.929 826.7C277.387 816.988 196.535 785.198 128.055 737.055C205.225 868.527 348.094 956.792 511.533 956.792C612.823 956.792 706.111 922.939 780.832 865.914L821.606 919.342C735.581 984.994 628.064 1024 511.533 1024C264.932 1024 59.156 849.535 10.7639 617.324C3.70462 583.45 0 548.373 0 512.467ZM361.192 793.344C361.189 793.345 361.147 793.282 361.076 793.157C361.159 793.281 361.195 793.343 361.192 793.344Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1005.58 379.652C1067.06 609.116 962.35 843.876 765.3 956.298L722.041 906.583C803.834 800.564 836.925 659.089 799.624 519.879C769.633 407.952 777.5 375.5 682.304 295.028C680.878 294.658 604.947 251.919 603.5 251.5C592.329 249.153 568.917 237.241 547 234.5C520.999 231.249 501.255 232.469 496 231.958L371.489 253.381L470.691 201.068C485.593 193.21 501.555 187.326 516.068 182.954L515.891 182.293C534.488 177.31 553.133 173.417 571.756 170.577C658.828 157.3 745.152 167.081 823.76 195.86C715.191 88.8406 554.346 40.5609 396.476 82.8622C298.637 109.078 217.29 165.921 159.875 240.342L106.662 199.289C172.763 113.609 266.521 48.104 379.081 17.9435C617.28 -45.8816 861.199 69.38 968.043 281.154C983.629 312.047 996.286 344.97 1005.58 379.652ZM583.998 201.829C584 201.828 584.057 201.877 584.158 201.979C584.046 201.881 583.996 201.831 583.998 201.829Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M348.23 741.109C292.537 689.925 257.633 616.474 257.633 534.871C257.633 380.211 383.01 254.835 537.669 254.835C590.593 254.835 640.088 269.516 682.304 295.028C632.444 249.205 565.921 221.229 492.864 221.229C338.204 221.229 212.828 346.606 212.828 501.266C212.828 603.002 267.079 692.066 348.23 741.109Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M492.864 781.302C647.524 781.302 772.9 655.926 772.9 501.266C772.9 419.661 737.995 346.208 682.299 295.024C763.453 344.066 817.706 433.132 817.706 534.87C817.706 689.53 692.33 814.906 537.67 814.906C464.615 814.906 398.094 786.932 348.235 741.111C390.449 766.622 439.942 781.302 492.864 781.302Z",
  fill: "currentColor"
});

const SvgCopilotFilled = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 1024,
  height: 1024,
  viewBox: "0 0 1024 1024",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCopilotFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/copilot-filled.b3fdd45f.svg";
export { ForwardRef as ReactComponent };